export const EXCEL_PROTECTION_PASSWORD = 'WorkpaperPassword';
export const SHEET_ROUTE_MAP: Record<string, string> = {
  'Bucket Report': '/input-data',
  'Translated Data': '/input-data',
  'Payment Extract': '/input-data',
  'History by Return': '/input-data',
  'History by State': '/input-data',
  'Credit Data': '/input-data',
  'Anybill Table': '/anybill-return',
  'Returns Calendar': '/return-calendar',
  'Credit Carry Forward': '/credit',
  'Tax Col Not Registered': '/credit',
  'Recon': '/recon',
};
export const WORKPAPER_CONTEXT_SETTINGS = {
  VertexCodeFromSheet: 'Cover Sheet',
  ClientEntityPeriodFromSheet: 'Admin',
  VertexCodeFromCellAddress: 'C8:C8',
  ClientEntityPeriodFromCellAddress: 'A2:E2',
};

export const WOKRPAPER_SHEETS = {
  CalcSheet: 'Calc',
  WorksheetsSheet: 'Worksheets',
  AdminUsersSheet: 'Admin Users',
  BucketReportSheet: 'Bucket Report',
  CarryForwardsBucketReportSheet: 'Carry Forwards Bucket Report',
  CarryForwardsPurchasesSheet: 'Carry Forwards Purchases',
  CarryForwardsSalesSheet: 'Carry Forwards Sales',
  CarryForwardsTaxSheet: 'Carry Forwards Tax',
  CarryForwardsUseTaxSheet: 'Carry Forwards Use Tax',
  EntitiesSheet: 'Entities',
  HistorybyReturnSheet: 'History by Return',
  HistorybyStateSheet: 'History by State',
  MasterReturnListSheet: 'Master Return List',
  MonthsSheet: 'Months',
  NonVertexReturnPaymentsSheet: 'Non Vertex Return Payments',
  PaymentExtractSheet: 'Payment Extract',
  PickListsSheet: 'Pick Lists',
  ReconSheet: 'Recon',
  ReconHistorySheet: 'Recon History',
  RefreshSheet: 'Refresh',
  ReturnsCalendarSheet: 'Returns Calendar',
  SubReconSheet: 'Sub Recon',
  TranslatedDataSheet: 'Translated Data',
  UnassignedDataSheet: 'Unassigned Data',
  ClientReviewSheet: 'Client Review',
  RollforwardSheet: 'Rollforward',
  PaymentExtractAdjustmentsSheet: 'Payment Extract Adjustments',
  BucketReportAdjustmentsSheet: 'Bucket Report Adjustments',
  CarryForwardsTaxByStateSheet: 'Carry Forwards Tax By State',
  CanadaReconSheet: 'Canada Recon',
  DataValidationSheet: 'Data Validation',
  PaymentRegisterSheet: 'Payment Register',
  PaymentsMetadataSheet: 'Payments Metadata',
  CreditCarryForwardSheet: 'Credit Carry Forward',
  TaxColNotregisteredSheet: 'Tax Col Not Registered',
  CBHRSheet: 'Credit Data'
}

export const LOCK_TOGGLE_ELIGIBLE_SHEETS: readonly string[] = [
  WOKRPAPER_SHEETS.BucketReportSheet,
  WOKRPAPER_SHEETS.HistorybyReturnSheet,
  WOKRPAPER_SHEETS.HistorybyStateSheet,
  WOKRPAPER_SHEETS.ReconSheet,
  WOKRPAPER_SHEETS.ReturnsCalendarSheet,
  WOKRPAPER_SHEETS.SubReconSheet,
  WOKRPAPER_SHEETS.TranslatedDataSheet,
  WOKRPAPER_SHEETS.CreditCarryForwardSheet,
  WOKRPAPER_SHEETS.TaxColNotregisteredSheet,
  WOKRPAPER_SHEETS.CBHRSheet,
  WOKRPAPER_SHEETS.PaymentExtractSheet,
];

export const POLLING_SETTINGS = {
  Last_Refresh_Polling_Interval: 90000, // 90 seconds
}
export const WORKBOOK_TABLES_TO_APPEND = ['ReturnCalendarData'];
export const WORKBOOK_SHEET_TABLE_NAMES = {
  ReturnsCalendar: 'ReturnCalendarData',
}
export const WORKBOOK_SHEET_TABLE_COLUMNS_IDENTIFIER = {
  ReturnsCalendar: 'EntityMasterReturnId',
}
export const WORKBOOK_TABLES_PRIMARY_HEADER_COLUMN ={
  ReturnsCalendar: 'Return Name',
}
export const ADDIN_DISPLAY_MESSAGES_DURATION = {
  Success: 3000,
  Error: 5000,
}

export const WRONG_SHEET_MESSAGE = 'Please switch to Returns Calendar sheet to perform this action.';

export const REVIEW_NOTES_MESSAGES ={
  ReviewNoteResolved: 'Review note resolved successfully',
  ReviewNoteAdded: 'Review note saved successfully.',
  ReviewNoteAddFailed: "Failed to save review note.",
  ReviewNoteUpdated: 'Review note updated successfully.',
  ReviewNoteUpdateFailed: "Failed to update review note.",
  ReviewNoteDeleted: 'Review note deleted successfully',
  ReturnsCalendarInvalidCellSelection: "Error: Don't select header & total rows or rows whose 'Return Name' is blank.",
  ReviewNoteCannotBeEmpty: "Note cannot be empty or whitespace only.",
  PermissionRestrictedToolTip: "You don't have permission to perform this action.",
  WrongSheet: WRONG_SHEET_MESSAGE,
}

export const SAVE_WORKSHEET_SETTINGS = {
  MAX_PAYLOAD_BYTES: 4_500_000,
};

export const REFRESH_TRIGGER = {
  Single: 'single',
  Section: 'section',
} as const;

export type RefreshTrigger = typeof REFRESH_TRIGGER[keyof typeof REFRESH_TRIGGER];

export const SHEET_LOAD_FAILURE_STAGE = {
  Api: 'api',
  Write: 'write',
  Restore: 'restore',
  Lifecycle: 'lifecycle',
} as const;

export type SheetLoadFailureStage = typeof SHEET_LOAD_FAILURE_STAGE[keyof typeof SHEET_LOAD_FAILURE_STAGE];

export const SECTION_REFRESH_LABELS = {
  RollOver: 'Roll Over',
  CurrentMonth: 'Current Month',
} as const;

export type SectionRefreshLabel = typeof SECTION_REFRESH_LABELS[keyof typeof SECTION_REFRESH_LABELS];

export const SECTION_REFRESH_MESSAGES = {
  ActionLabel: 'Refresh All',
} as const;

export const REFRESH_LOAD_MESSAGES = {
  LoadFailed: 'Load failed',
} as const;

export const WORKBOOK_ERROR_MESSAGES = {
  UnknownError: 'Unknown error',
} as const;

export const WORKPAPER_OPERATION_KIND = {
  SheetLoad: 'sheet-load',
  SectionRefresh: 'section-refresh',
  Save: 'save',
  SheetLockToggle: 'sheet-lock-toggle',
} as const;

export type WorkpaperOperationKind = typeof WORKPAPER_OPERATION_KIND[keyof typeof WORKPAPER_OPERATION_KIND];

export const WORKPAPER_OPERATION_LABELS = {
  Save: 'Save',
  Toggle: 'Toggle',
} as const;

export const WORKPAPER_OPERATION_MESSAGES = {
  OperationInProgress: 'Another workpaper operation is already in progress.',
  SaveBlocked: 'Cannot save worksheet: another workpaper operation is already in progress.',
} as const;
